import React from "react"
import { createIcon } from "@chakra-ui/react"

export default createIcon({
  displayName: "CableWithPlugIcon",
  viewBox: "0 0 127 122",
  defaultProps: {
    fill: "none",
  },
  path: [
    <path
      d="M121 61C121 94.1371 94.1371 121 61 121C27.8629 121 1 94.1371 1 61C1 27.8629 27.8629 1 61 1"
      stroke="url(#paint0_linear_3172_24686)"
      strokeWidth="2"
    />,
    <path
      d="M127 55C127 58.866 123.866 62 120 62C116.134 62 113 58.866 113 55L113 50L127 50L127 55Z"
      fill="currentColor"
    />,
    <path
      d="M125 50L122 50L122 46.5C122 45.6716 122.672 45 123.5 45C124.328 45 125 45.6716 125 46.5L125 50Z"
      fill="currentColor"
    />,
    <path
      d="M118 50L115 50L115 46.5C115 45.6716 115.672 45 116.5 45C117.328 45 118 45.6716 118 46.5L118 50Z"
      fill="currentColor"
    />,
    <path
      d="M122.5 52.5L117.5 57.5M117.5 52.5L122.5 57.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
    <defs>
      <linearGradient
        id="paint0_linear_3172_24686"
        x1="122.5"
        y1="1"
        x2="122.5"
        y2="62.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="currentColor" stopOpacity="0" />
        <stop offset="1" stopColor="currentColor" />
      </linearGradient>
      <clipPath id="clip0_3172_24686">
        <rect x="33" y="33" width="56" height="56" rx="28" fill="white" />
      </clipPath>
    </defs>,
  ],
})
